/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import RatingModal from "../../Modals/rating";
import { Button } from "@mui/material";
import { useLazyGetPropertyQuery } from "../../services/customer";
import { Property } from "../../types/General";
import { PROPERTY_TYPE } from "../../utils/enums";

const PropertyList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [getProperty] = useLazyGetPropertyQuery();

  const [open, setOpen] = useState(false);
  const [properties, setProperties] = useState<Property[]>([]);
  const [count, setCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const columns: GridColDef<(typeof properties)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "name",
      headerName: "Property Name",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "type",
      headerName: "Property Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p>
            {PROPERTY_TYPE[Number(row?.type)]
              ?.toLowerCase()
              ?.replace(/^\w/, (c) => c.toUpperCase())}
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "address",
      headerName: "Address",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 120,
      field: "city",
      headerName: "City",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 120,
      field: "amountS",
      headerName: "Amount Spent",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p className="c_success">
            <strong>AED {row?.amountSpent || "0"}</strong>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "issues",
      headerName: "Issues Raised",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Button
            className="btn sm btn_primary"
            onClick={() => navigate(`/manage-customers/issues/${row?._id}`)}
          >
            View
          </Button>
        );
      },
    },
  ];

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const getAllProperty = async () => {
    try {
      const response = await getProperty({
        page,
        limit: 10,
        search: "",
        role: 1,
        userId: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setProperties(response?.data?.list || []);
        setCount(response?.data?.totalCount);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getAllProperty();
    }
  }, [id]);
  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={properties}
          count={count}
          page={page}
          onPageChange={handlePageChange}
          loading={isLoading}
        />
      </div>

      <RatingModal open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default PropertyList;
